<template>
  <v-card class="actions-dialog">
    <v-card-title class="actions-dialog__close pa-0">
      <v-btn
        text
        icon
        plain
        depressed
        class="ma-0"
        @click="close"
      >
        <v-icon
          small
        >
          mdi-close-thick
        </v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text class="pt-0">
      {{ dialogText }}
    </v-card-text>

    <v-card-text
      v-if="supportText"
      class="py-0 font-weight-bold"
    >
      {{ supportText }}
    </v-card-text>

    <v-card-actions class="actions-dialog__actions px-0 py-4 ma-0">
      <v-btn
        class="actions-dialog__btn"
        medium
        depressed
        outline
        color="#140C22"
        @click="firstAction"
      >
        {{ firstText }}
      </v-btn>
      <v-btn
        class="actions-dialog__btn ma-0"
        medium
        depressed
        dark
        color="#140C22"
        @click="secondAction"
      >
        {{ secondText }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    dialogText: {
      type: String,
      default: '',
    },
    supportText: {
      type: String,
      default: '',
    },
    firstText: {
      type: String,
      default: '',
    },
    secondText: {
      type: String,
      default: '',
    },
    firstAction: {
      type: Function,
      default: () => {},
    },
    secondAction: {
      type: Function,
      default: () => {},
    },
    close: {
      type: Function,
      default: () => {},
    },
  },
};
</script>

<style scoped lang="scss">

.actions-dialog {
  width: 100%;
  font-family: 'Nunito Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  text-transform: none;
  border-radius: 7px;
  &__actions {
    display: flex;
    flex-flow: column wrap;
    justify-content: space-between;
    align-items: center;
    height: 140px;
  }
  &__btn {
    width: 288px;
    height: 42px;
    border-radius: 7.08982px;
    text-transform: none;
    font-weight: 600;
  }
  &__close {
    display: flex;
    justify-content: end;
  }
}

</style>
